module.exports = __webpack_public_path__ + "img/Loading-AN.04f45248.gif";